import React, { useContext, useEffect } from "react";

import LoaderSpinner from "@components-shared/LoaderSpinner";
import { DepositContext } from "@state/context/payment/DepositContext";
import { useFixBody } from "@state/hooks/shared";
import { observer } from "mobx-react";

import DepositLimitCreditRating from "./components/DepositLimitCreditRating";
import DepositLimitHeader from "./components/DepositLimitHeader";
import DepositLimitIncreaseLimit from "./components/DepositLimitIncreaseLimit";
import DepositLimitNone from "./components/DepositLimitNone";
import DepositLimitPartialDeposit from "./components/DepositLimitPartialDeposit";

export default observer(function DepositLimitPopup() {
	const depositStore = useContext(DepositContext);

	useFixBody(
		depositStore.depositLimitStore.isDepositLimitPopupActive,
		depositStore.depositLimitStore.isDepositLimitPopupActive
	);

	useEffect(() => {
		return () => {
			depositStore.depositLimitStore.onDispose();
		};
	}, []);

	useEffect(() => {
		if (
			depositStore.depositLimitStore.isDepositLimitPopupActive &&
			depositStore.depositLimitStore.limitData
		) {
			depositStore.depositLimitStore.fetchStarterLossLimitValue();
		}
	}, [
		depositStore.depositLimitStore.isDepositLimitPopupActive,
		depositStore.depositLimitStore.limitData,
	]);

	if (!depositStore.depositLimitStore.isDepositLimitPopupActive) {
		return null;
	}

	if (depositStore.depositLimitStore.limitData == null) {
		return null;
	}

	return (
		<div className="popup">
			<div className="popup__card popup__card--med">
				<LoaderSpinner
					isLoading={depositStore.depositLimitStore.isLoadingProcess}
				/>

				<DepositLimitHeader />
				<DepositLimitIncreaseLimit />
				<DepositLimitCreditRating />
				<DepositLimitPartialDeposit />
				<DepositLimitNone />
			</div>
		</div>
	);
});
